const technologies = [
  {
    title: 'AI Energy Platform',
    desc: 'AI 기반 에너지 수요 예측 및 최적화 플랫폼',
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20artificial%20intelligence%20brain%20network%20with%20energy%20nodes%20and%20glowing%20connections%20on%20dark%20background%20neon%20cyan%20and%20green%20data%20streams%20futuristic%20AI%20energy%20platform%20visualization%20dark%20tech%20aesthetic%20high%20quality%203D%20render&width=600&height=600&seq=tech1&orientation=squarish',
  },
  {
    title: 'Digital Twin',
    desc: '에너지 인프라의 실시간 디지털 복제 모델',
    image:
      'https://readdy.ai/api/search-image?query=Digital%20twin%20technology%203D%20holographic%20city%20model%20with%20energy%20grid%20overlay%20dark%20slate%20background%20neon%20cyan%20wireframe%20buildings%20green%20energy%20flow%20lines%20futuristic%20simulation%20visualization%20high%20quality%203D%20render&width=600&height=600&seq=tech2&orientation=squarish',
  },
  {
    title: 'Smart Grid',
    desc: '지능형 전력망 운영 및 관리 시스템',
    image:
      'https://readdy.ai/api/search-image?query=Smart%20electrical%20grid%20network%20visualization%20with%20glowing%20nodes%20and%20power%20lines%20dark%20background%20neon%20cyan%20energy%20pulses%20green%20renewable%20energy%20symbols%20futuristic%20power%20distribution%20system%20high%20quality%203D%20render&width=600&height=600&seq=tech3&orientation=squarish',
  },
  {
    title: 'Distributed Energy',
    desc: '분산형 재생에너지 네트워크 통합 솔루션',
    image:
      'https://readdy.ai/api/search-image?query=Distributed%20energy%20network%20mesh%20topology%20with%20interconnected%20solar%20panels%20and%20wind%20turbines%20dark%20slate%20background%20neon%20cyan%20connection%20lines%20green%20energy%20particles%20futuristic%20decentralized%20power%20grid%20high%20quality%203D%20render&width=600&height=600&seq=tech4&orientation=squarish',
  },
];

export default function TechnologySection() {
  return (
    <section id="technology" className="relative py-24 md:py-32 bg-enerverze-bg bg-grid-pattern">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="mb-16">
          <p className="text-sm text-enerverze-subtle mb-4">Core Technologies</p>
          <div className="flex items-start justify-between">
            <h2 className="text-4xl md:text-6xl lg:text-7xl font-bold text-enerverze-text leading-tight">
              핵심 기술
              <br />
              <span className="text-neon-cyan italic">Innovation</span>
            </h2>
            <div className="hidden lg:flex items-center justify-center w-16 h-16">
              <i className="ri-shining-line text-neon-green text-4xl"></i>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {technologies.map((tech) => (
            <div
              key={tech.title}
              className="group rounded-3xl overflow-hidden bg-enerverze-card border border-enerverze-border hover:border-neon-cyan transition-all duration-300"
            >
              <div className="h-64 md:h-72 flex items-center justify-center overflow-hidden">
                <img
                  src={tech.image}
                  alt={tech.title}
                  className="w-full h-full object-cover object-center group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6 border-t border-enerverze-border">
                <h3 className="text-lg font-semibold text-enerverze-text mb-2">
                  {tech.title}
                </h3>
                <p className="text-sm text-enerverze-muted">{tech.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}